<template>
  <!-- TODO: move all positioning to .circle-btn-wrap -->
  <div class="circle-btn-wrap circle-btn-wrap--overlap">
    <transition name="grow">
      <button
        v-show="show"
        v-on:click="onClick"
        :class="showButton ? '': 'circle-btn--hide'"
        class="circle-btn"
      >{{buttonText}}</button>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    onClick: Function,
    showButton: Boolean
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    buttonText() {
      // if we pass in text, use it. otherwise we can grab the text from the url parameter
      if (this.text) {
        return this.text;
      } else {
        if (this.$route.name === "feeling-lucky" && !this.$route.params.id) {
          return "Hit Me";
        } else {
          let flucky = this.$store.state.feelingLucky.find(
            fl => fl.Id === parseInt(this.$route.params.id)
          );
          return flucky.Text;
        }
      }
    }
  },
  mounted() {
    // show feeling lucky button on load
    this.show = true;

    if (!this.text) {
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../scss/variables";

.grow-enter-active,
.grow-leave-active {
  transition: opacity 0.2s, transform 0.25s cubic-bezier(0.17, 0.67, 0.41, 1.5);
  transition-delay: 0.2s;
}
.grow-enter,
.grow-leave-to {
  opacity: 0;
  transform: scale(0.5);
}

.circle-btn-wrap {
  &--overlap {
    position: absolute;
    top: 30.143%;
    left: auto;
    right: -2.5em;
    z-index: 1;
    @media (min-height: 600px) {
      top: 47.143%;
    }
    @media (min-width: 600px) {
      top: 50%;
      left: auto;
      right: 1.5rem;
      transform: translateX(50%);
    }
    @media (min-width: 768px) {
      left: auto;
      top: 55.909%;
      bottom: auto;
      right: 1.5rem;
      transform: translateX(50%);
    }
    @media (min-width: 992px) {
      bottom: auto;
      top: 70%;
      left: auto;
      right: 1.5rem;
      transform: translateX(50%) translateY(-50%);
      @media (min-height: 560px) {
        top: 60%;
      }
      @media (min-height: 680px) {
        top: 44.776%;
        transform: translateX(50%);
      }
    }
  }
}

.circle-btn {
  display: block;
  background-color: transparent;
  color: white;
  width: 125px;
  height: 125px;
  border: none;
  text-transform: uppercase;
  font-weight: bold;
  font-family: $font;
  font-size: 0.9em;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    transition: transform 0.2s;
    border-radius: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: black;
    z-index: -1;
  }

  @media (min-width: 768px) {
    @media (min-height: 750px) {
      width: 186px;
      height: 186px;
    }
  }

  @media (min-width: 992px) {
    width: 172px;
    height: 172px;
    &:hover {
      cursor: pointer;
      &:after {
        transform: scale(1.1);
      }
    }
  }
  &--hide {
    visibility: hidden;
  }
}
</style>
